

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {Register} from "../models/register";
import {useStore} from "vuex";
import {RegisterUser} from "@/models/registerUser";
import {AccountPermission} from "@/models/accountPermission";
import {DichVuCreate} from "@/models/dichVuCreate";
import {DichVu} from "@/models/dichVu";
import moment from 'moment';
import {FilterMatchMode} from "primevue/api";
import {LieuTrinhCreate} from "@/models/lieuTrinhCreate";
import {LieuTrinh} from "@/models/lieuTrinh";
import {SanPhamCreate} from "@/models/sanPhamCreate";
import {SanPham} from "@/models/sanPham";
import {KhachHangCreate} from "@/models/khachHangCreate";
import {KhachHang} from "@/models/khachHang";
import {KhachHangUpdate} from "@/models/khachHangUpdate";

export default {

  setup(){
    const router = useRouter();
    const khachHangCreate = ref({} as KhachHangCreate);
    const khachHangUpdate = ref({} as KhachHangUpdate);
    const listKhachHang = ref([] as KhachHang[]);
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const showUpdate = ref(false);
    if (!!!store.state.token) {
      router.push({ name: "home" });
    }

    const validKhachHang = computed(()=>  khachHangCreate.value.tenKhachHang && khachHangCreate.value.diaChi  && khachHangCreate.value.soDienThoai?.length >=10 && khachHangCreate.value.ngaySinh );
    const validKhachHangUpdate = computed(()=>  khachHangUpdate.value.tenKhachHang && khachHangUpdate.value.diaChi  && khachHangUpdate.value.soDienThoai?.length >=10 && khachHangUpdate.value.ngaySinh );


    const getListKhachHang = () => {
      AuthRepository.getListKhachHang()
          .then((response) => {
            listKhachHang.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }
    getListKhachHang();

    const createKhachHang = () => {
      console.log("######################### createKhachHang");
      console.log("######################### createKhachHang khachHangCreate: " + JSON.stringify(khachHangCreate.value));
        AuthRepository.createKhachHang(khachHangCreate.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Đăng ký khách hàng thành công',
              life: 2000
            });
            getListKhachHang();
            const temp = ref({} as KhachHangCreate);
            khachHangCreate.value = temp.value;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const selectKhachHang = (id) => {
      listKhachHang.value.forEach(x =>{
        if(x.id == id){
          khachHangUpdate.value.tenKhachHang = x.tenKhachHang;
          khachHangUpdate.value.diaChi = x.diaChi;
          khachHangUpdate.value.ngaySinh = x.ngaySinh;
          khachHangUpdate.value.soDienThoai = x.soDienThoai;
          khachHangUpdate.value.id = x.id;
          showUpdate.value = true;
        }
      })
    }

    const formatDateTime = (date) => {
      if((date == null)||(date == ''))
      {
        return "";
      }
      else
        return moment(String(date)).format(' DD/MM/YYYY');
    };
    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    const formatCurrency = (money) => {
      // Use Intl.NumberFormat to format the number as currency
      const formatter = new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
        minimumFractionDigits: 0, // Set the number of decimal places you want
      });
      return formatter.format(money);
    };

    const updateKhachHang = () => {
      console.log("######################### updateKhachHang");
      console.log("######################### updateKhachHang khachHangUpdate: " + JSON.stringify(khachHangUpdate.value));
      AuthRepository.updateKhachHang(khachHangUpdate.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Cập nhật dữ liệu khách hàng thành công',
              life: 2000
            });
            getListKhachHang();
            showUpdate.value = false;
            const temp = ref({} as KhachHangUpdate);
            khachHangUpdate.value = temp.value;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    return {
      error,
      createKhachHang,
      khachHangCreate,
      listKhachHang,
      validKhachHang,
      formatDateTime,
      filters,
      clearFilter,
      initFilters,
      formatCurrency,
      selectKhachHang,
      showUpdate,
      khachHangUpdate,
      updateKhachHang,
      validKhachHangUpdate,
      // donVi,
    }
  }
}

